const StarIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="43" height="43" rx="11.5" fill="#F2F3F5" />
      <rect x="0.5" y="0.5" width="43" height="43" rx="11.5" stroke="#D7D7D8" />
      <path
        d="M27.9185 24.32C27.6595 24.571 27.5405 24.934 27.5995 25.29L28.4885 30.21C28.5635 30.627 28.3875 31.049 28.0385 31.29C27.6965 31.54 27.2415 31.57 26.8685 31.37L22.4395 29.06C22.2855 28.978 22.1145 28.934 21.9395 28.929H21.6685C21.5745 28.943 21.4825 28.973 21.3985 29.019L16.9685 31.34C16.7495 31.45 16.5015 31.489 16.2585 31.45C15.6665 31.338 15.2715 30.774 15.3685 30.179L16.2585 25.259C16.3175 24.9 16.1985 24.535 15.9395 24.28L12.3285 20.78C12.0265 20.487 11.9215 20.047 12.0595 19.65C12.1935 19.254 12.5355 18.965 12.9485 18.9L17.9185 18.179C18.2965 18.14 18.6285 17.91 18.7985 17.57L20.9885 13.08C21.0405 12.98 21.1075 12.888 21.1885 12.81L21.2785 12.74C21.3255 12.688 21.3795 12.645 21.4395 12.61L21.5485 12.57L21.7185 12.5H22.1395C22.5155 12.539 22.8465 12.764 23.0195 13.1L25.2385 17.57C25.3985 17.897 25.7095 18.124 26.0685 18.179L31.0385 18.9C31.4585 18.96 31.8095 19.25 31.9485 19.65C32.0795 20.051 31.9665 20.491 31.6585 20.78L27.9185 24.32Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default StarIcon;
